import { Injectable } from "@angular/core";
import { HttpResponse } from "@angular/common/http";
import { HttpService } from "../http/http.service";
import { ExportTypeFormat } from "./export-type.enum";

@Injectable({
	providedIn: "root",
})
export class ExportService {
	constructor(private http: HttpService) {}

	public exportCSV(endpoint: string, _filter: any): void {
		const filter = {
			..._filter,
			Export: true,
			FormatType: ExportTypeFormat.CSV,
		};

		this.downloadFile(endpoint, filter);
	}

	public exportCustom(
		endpoint: string,
		_filter: any,
		customTypeFormat: number
	): void {
		const filter = {
			..._filter,
			Export: true,
			FormatType: customTypeFormat,
		};

		this.downloadFile(endpoint, filter);
	}

	public exportCSVIds(endpoint: string, ids: string[]): void {
		this.downloadFile(endpoint, ids);
	}

	public exportXlsx(endpoint: string, _filter: any) {
		const filter = {
			..._filter,
			FormatType: ExportTypeFormat.XLSX,
		};

		this.downloadFile(endpoint, filter);
	}

	private downloadFile(endpoint: string, filter: any) {
		this.http.postFile(`${endpoint}`, filter).subscribe((data) => {
			const url = window.URL.createObjectURL(data.file);
			const link = document.createElement("a");
			link.download = this.getFilenameFromContentDisposition(data.title);
			link.href = url;
			link.click();
			URL.revokeObjectURL(url);
			link.remove();
		});
	}

	private getFilenameFromContentDisposition(
		contentDisposition: string
	): string {
		const regex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
		const matches = regex.exec(contentDisposition);
		if (matches != null && matches[1]) {
			return matches[1].replace(/['"]/g, "");
		}
		return "";
	}
	public exportJSON(apiEndpoint: string, filename: string, filter: any): any {
		this.http.post<any>(`/api/${apiEndpoint}`, filter).subscribe((data) => {
			var json = JSON.stringify(data, null, "\t");
			this.downloadJSON(json, filename + ".json");
		});
	}

	private downloadJSON(json: string, filename: string): void {
		var blob = new Blob([json], {
			type: "data:application/json;charset=utf-8",
		});

		var link = document.createElement("a");
		link.setAttribute("href", window.URL.createObjectURL(blob));
		link.setAttribute("download", filename);
		document.body.appendChild(link); // Required for FF
		link.click();
		document.body.removeChild(link);
	}
}
